import React, { Fragment } from "react"
import { PlanVisual } from "./janowoTwoStyle"
import { Col, Container, Row } from "react-bootstrap"

const JanowoTwoVisual = ({ image, alt = " " }) => {
  return (
    <Fragment>
      <PlanVisual>
        <Container style={{ margin: "0 auto", padding: 0 }} fluid>
          <Row>
            <Col style={{ margin: "0 auto", padding: 0 }} xs="0" sm="0" md="12">
              {/*<div className="plan-wiz" style={{ 'background-image': `url(${image})`, 'background-position': 'center bottom' }} />*/}
              <div style={{ textAlign: "center" }}>
                <img src={image} alt={alt} />
              </div>
            </Col>
          </Row>
        </Container>
      </PlanVisual>
    </Fragment>
  )
}

export default JanowoTwoVisual
